import React, { useEffect, useMemo, useRef } from 'react'
import * as d3 from 'd3'
import R from 'ramda'
import { Pattern } from './DailyEventTypeDescription'
import { sortStringArray } from '../../core/utils'
import DaillyRectBarList from './DailyRectBarList'
const DailyGraph2 = ({
  data,
  totalWidth = 800,
  height = 500,
  forceHeight,
  showGraphHeaders = true,
  ...props
}) => {
  const svgRef = useRef()

  const yMargin = 100
  const labelWidth = 50
  const width = totalWidth - labelWidth
  const xMargin = 100
  // const maxHour = 24 // it should 23
  // const minHour = 0
  let graphHeight = height

  const { graphData = [] } = data

  const nameList = R.compose(
    // R.sort,
    sortStringArray,
    R.uniq,
    R.map(u => u.shortName)
  )(graphData)

  graphHeight = nameList.length * 35
  graphHeight = graphHeight < height ? height : graphHeight
  const yScale = useMemo(
    _ => {
      return d3
        .scaleBand()
        .range([0, graphHeight - xMargin])
        .domain(nameList)
      // .paddingInner(0.1)
      // .paddingOuter(0.1)
      // .nice()
    },
    [graphHeight, nameList]
  )

  useEffect(
    _ => {
      if (svgRef.current) {
        const svg = d3.select(svgRef.current)
        // d3.selectAll('#xid').remove()
        d3.selectAll('#yid').remove()
        svg
          .append('g')
          .attr('id', 'yid')
          .attr('transform', 'translate(' + yMargin + ',' + 0 + ')')
          .call(
            d3.axisLeft(yScale)
            // .tickValues(R.range(minHour, maxHour + 1))
            // .tickSize(1)
          )
      }
    },
    [yScale]
  )

  const xScale = useMemo(
    _ => {
      // const domain = R.compose(
      //   R.flatten,
      //   R.map(h => R.range(0, 6).map(m => h + m / 10)),
      //   _ => R.range(minHour, maxHour + 2)
      // )()
      return (
        d3
          .scaleLinear()
          // .domain(domain)
          .domain([0, 25])
          .range([yMargin, width])
      )
      // .rangeRoundBands([0, height])
    },
    [width]
  )

  // useEffect(
  //   _ => {
  //     if (svgRef.current) {
  //       const svg = d3.select(svgRef.current)
  //       d3.selectAll('#xid').remove()
  //       // d3.selectAll('#yid').remove()
  //       svg
  //         .append('g')
  //         .attr('id', 'xid')
  //         .attr('transform', 'translate(' + 0 + ',' + 15 + ')')
  //         .call(d3.axisTop(xScale).tickValues(R.range(0, 25)))
  //     }
  //   },
  //   [height, xScale]
  // )

  const PatternList = useMemo(
    _ =>
      R.compose(
        R.map(({ stripeRed, stripeGreen, stripeBlue }) => (
          <Pattern
            key={'' + stripeRed + stripeGreen + stripeBlue}
            id={'' + stripeRed + stripeGreen + stripeBlue}
            rgb={`rgb(${stripeRed},${stripeGreen},${stripeBlue})`}
          />
        )),
        R.uniq,
        R.map(({ stripeRed, stripeGreen, stripeBlue }) => ({
          stripeRed,
          stripeGreen,
          stripeBlue,
        })),
        R.filter(({ stripeRed }) => !!stripeRed)
      )(graphData),
    [graphData]
  )
  const xBandWidth = useMemo(_ => xScale(1) - xScale(0), [xScale])

  props.setXBandsWidth && props.setXBandsWidth(xBandWidth)

  return (
    <div style={{ height: '100%' }}>
      {showGraphHeaders && (
        <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
          <div style={{ minWidth: yMargin + 'px' }} />
          {R.range(0, 24).map(i => (
            <div
              key={i + 'hi'}
              style={{
                backgroundColor: '#e1dbdb',
                border: '1px solid black',
                width: xBandWidth + 'px',
                display: 'grid',
                justifyContent: 'center',
              }}
            >
              {i}
            </div>
          ))}
        </div>
      )}
      <div
        style={{
          overflowX: 'hidden',
          overflowY: 'auto',
          maxHeight: forceHeight || height + 'px',
          height: forceHeight || height + 'px',
          // backgroundColor: 'yellow',
          ...(props.svgDivStyle || {}),
        }}
      >
        <svg ref={svgRef} width={width} height={forceHeight || graphHeight}>
          <g key="pattern"> {PatternList}</g>

          <DaillyRectBarList
            svgRef={svgRef}
            data={data}
            xScale={xScale}
            yScale={yScale}
            {...props}
            nameList={nameList}
            height={height}
            width={width}
            xMargin={xMargin}
            yMargin={yMargin}
            graphHeight={graphHeight}
          />
        </svg>
      </div>
    </div>
  )
}

export default DailyGraph2
